import { useModule, videoVotingModuleQuery } from 'system/structure-modules';

export default function VideoVotingEditScreen() {
    const { EditVideoVotingScreen } = useModule(videoVotingModuleQuery);
    return <EditVideoVotingScreen />;
}
